import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store/index";

// Requests
import { getMigrationScript, getMigrations, postMigrateAll, postMigrateCurrent } from "@/requests/developer";

// Models
import { Migrations } from "@/models/api/developer/Migrations";
import { MigrationItem } from "@/models/api/developer/MigrationItem";
import { MigrationScript } from "@/models/api/developer/MigrationScript";

export interface DeveloperStateInterface {
  migrations: Migrations | null;
  selectedMigration: MigrationItem | null;
  selectedMigrationSqlScript: MigrationScript | null;
  migrationSQLDialog: boolean;
}

export const DeveloperState: DeveloperStateInterface = {
  migrations: null,
  selectedMigration: null,
  selectedMigrationSqlScript: null,
  migrationSQLDialog: false,
};

const DeveloperModule = defineModule({
  state: DeveloperState as DeveloperStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setMigrations(state, param: Migrations | null) {
      state.migrations = param;
    },
    setSelectedMigration(state, param: MigrationItem | null) {
      state.selectedMigration = param;
    },
    setSelectedMigrationSqlScript(state, param: MigrationScript | null) {
      state.selectedMigrationSqlScript = param;
    },
    setMigrationSqlDialog(state, param: boolean) {
      state.migrationSQLDialog = param;
    },
  },
  actions: {
    async getMigrations(context) {
      const { commit } = _moduleActionContext(context);
      const result = await getMigrations();
      commit.setMigrations(result);
    },
    async migrateAll(context) {
      const { dispatch, rootDispatch } = _moduleActionContext(context);
      await postMigrateAll();
      rootDispatch.popup.addOperationSuccessfulSnackbar();
      dispatch.getMigrations();
    },
    async migrateCurrent(context) {
      const { dispatch, rootDispatch } = _moduleActionContext(context);
      await postMigrateCurrent();
      rootDispatch.popup.addOperationSuccessfulSnackbar();
      dispatch.getMigrations();
    },
    async getMigrationScript(context) {
      const { state, commit } = _moduleActionContext(context);
      if (state.selectedMigration != null) {
        const prevoius = state.selectedMigration.previousFullName;
        const current = state.selectedMigration.fullName;
        const result = await getMigrationScript(current, prevoius);
        commit.setSelectedMigrationSqlScript(result);
      }
    },
    async selectItemAndShowDialog(context, item: MigrationItem) {
      const { commit, dispatch } = _moduleActionContext(context);
      commit.setSelectedMigration(item);
      await dispatch.getMigrationScript();
      commit.setMigrationSqlDialog(true);
    },
    async clearItemAndHideDialog(context) {
      const { commit } = _moduleActionContext(context);
      commit.setSelectedMigration(null);
      commit.setMigrationSqlDialog(false);
    },
  },
});

export default DeveloperModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, DeveloperModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, DeveloperModule);
